var _g, _g2, _g3, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMainBackgroundMobile = function SvgMainBackgroundMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 375 312",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#main-background-mobile_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.455 18.646H193.04V136.69c0 9.196-7.455 16.651-16.652 16.651H59.455V18.646Z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#main-background-mobile_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M291 163.99h92.88V86.652c0-9.197-7.456-16.652-16.652-16.652H291v93.99Z",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#main-background-mobile_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-58.957 153.34H59.455v98.598c0 11.725-9.505 21.23-21.23 21.23h-97.182V153.34Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "main-background-mobile_svg__a",
    x: 41.569,
    y: 0.76,
    width: 181.281,
    height: 182.391,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5.962,
    dy: 5.962
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.924
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_440_265"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_440_265",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "main-background-mobile_svg__b",
    x: 273.114,
    y: 52.114,
    width: 140.577,
    height: 141.687,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5.962,
    dy: 5.962
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.924
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_440_265"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_440_265",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "main-background-mobile_svg__c",
    x: -81.76,
    y: 130.537,
    width: 179.221,
    height: 180.636,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 7.601,
    dy: 7.601
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15.202
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_440_265"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_440_265",
    result: "shape"
  })))));
};

export { SvgMainBackgroundMobile as ReactComponent };
export default __webpack_public_path__ + "51b69ee2d0e78d23f9fe4abaa25993a5.svg";